import type {
  PersonnelType,
  SelectMetadataVO,
  SelectionMetadata,
} from "@ifa/utils";

export const PERSONNEL_TYPE_METADATA_CODE = "PERSONNEL_TYPE";

type PersonnelTypeOption = {
  label: string;
  value: PersonnelType;
};

function findPersonnelTypeMetadata(
  selectMetadataList: SelectMetadataVO[]
): SelectMetadataVO | undefined {
  return selectMetadataList.find(
    (metadata) => metadata.code === PERSONNEL_TYPE_METADATA_CODE
  );
}

function toPersonnelTypeOption(
  item: SelectionMetadata
): PersonnelTypeOption | null {
  if (!item.key || !item.name) {
    return null;
  }

  return {
    value: item.key as PersonnelType,
    label: item.name,
  };
}

export function getPersonnelTypeOptions(
  selectMetadataList: SelectMetadataVO[]
): PersonnelTypeOption[] {
  const metadata = findPersonnelTypeMetadata(selectMetadataList);
  return (
    metadata?.items
      ?.map(toPersonnelTypeOption)
      .filter((item): item is PersonnelTypeOption => item !== null) ?? []
  );
}

export function getPersonnelTypeLabel(
  value: PersonnelType | undefined,
  selectMetadataList: SelectMetadataVO[]
) {
  if (!value) {
    return undefined;
  }

  const metadata = findPersonnelTypeMetadata(selectMetadataList);
  return metadata?.items?.find((item) => item.key === value)?.name;
}
